import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { PaymentMethod } from '../../../../../../../../data/dietitian/domain/subscription/payment_method';
import { FeatureModel } from '../../account-subscription.component';
import { FeatureSubscriptionConfirmationPopupFacade } from './feature-subscription-confirmation-popup.facade';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-feature-subscription-confirmation-popup',
  templateUrl: './feature-subscription-confirmation-popup.component.html',
  styleUrls: ['./feature-subscription-confirmation-popup.component.scss'],
  providers: [FeatureSubscriptionConfirmationPopupFacade],
})
export class FeatureSubscriptionConfirmationPopupComponent {
  @Input() model: FeatureModel | undefined;
  @Output() cancel = new EventEmitter();
  @Output() validate = new EventEmitter<string | undefined>();

  coupon: string | undefined;
  loadingPaymentMethods = true;
  errorPaymentMethods?: string | undefined;
  paymentMethods: PaymentMethod[];

  constructor(
    private bsModalRef: BsModalRef,
    private facade: FeatureSubscriptionConfirmationPopupFacade,
  ) {
    this.loadPaymentMethods().then();
  }

  hideModal() {
    this.bsModalRef.hide();
  }

  async loadPaymentMethods() {
    this.loadingPaymentMethods = true;
    try {
      const methods = await this.facade.getPaymentMethods();
      if (methods.length === 1) {
        this.paymentMethods = methods;
      } else {
        this.paymentMethods = (await this.facade.getPaymentMethods()).filter(
          (pm) => pm.default,
        );
      }
    } catch (err: any) {
      this.errorPaymentMethods = err;
    } finally {
      this.loadingPaymentMethods = false;
    }
  }

  get title(): string {
    if (this.model && this.model.stripeProduct) {
      return 'Abonnement ' + (this.model?.stripeProduct?.name ?? '') + ' ?';
    } else {
      return 'Erreur...';
    }
  }

  get subtitle(): string {
    if (this.model && this.model.stripeProduct) {
      return (
        "Vous souhaitez vous abonner à l'option " +
        this.model.stripeProduct.name +
        ' ? Un prélèvement mensuel sera alors mis en place sur votre mode de paiement par défaut : '
      );
    } else {
      return "Une erreur s'est produite. Veuillez essayer à nouveau, ultérieurement !";
    }
  }
}
